import numeral from 'numeral';

// Poor-mans regular expression escape'er
const escape = (symbol: string) => {
    switch (symbol) {
        case '.':
            return '\\.';
        default:
            return symbol;
    }
};

export const parseDecimalToFloat = (str?: number | string): number | null => {
    if (!str) {
        return null;
    }

    if (typeof str === 'number') {
        return str;
    }

    const delimiters = (numeral as any).localeData().delimiters;
    const floatStr = str.replace(new RegExp(escape(delimiters.thousands), 'g'), '').replace(delimiters.decimal, '.');
    const float = parseFloat(floatStr);
    return isNaN(float) ? null : float;
};

export const isNumber = (n: any) => {
    const parsedNumber = parseFloat(n);
    return n !== null && !isNaN(parsedNumber);
};
